module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466805798_fm01#fm01"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466805798_fm02#fm02"
    }
  }, [_vm._v("Biographies")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466805798_fm03#fm03"
    }
  }, [_vm._v("Chronology")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466805798_fm04#fm04"
    }
  }, [_vm._v("Tables of Genealogy")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "3%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466805798_fm05#fm05"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781466805798_ch01#ch01"
    }
  }, [_vm._v("1. Marriages, Birth and Death")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Last Will and Testament")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Second Josiah")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Milder Climates")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Downfall of the Lord Admiral")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Commotion Time")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Coup d’Etat")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Uncertain Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Hidden Conspiracies")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Destruction of the Duke")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. An Emerging King")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Promise Unfulfilled")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Nemesis")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "4%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "3%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_ack01#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "4%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_end01#end01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "4%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781466805798_indx01#indx01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-622f0210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466805798_con01.vue
// module id = 66
// module chunks = 0